import { render, staticRenderFns } from "./ColorFilter.vue?vue&type=template&id=db25875e&scoped=true&"
import script from "./ColorFilter.vue?vue&type=script&lang=js&"
export * from "./ColorFilter.vue?vue&type=script&lang=js&"
import style0 from "./ColorFilter.vue?vue&type=style&index=0&id=db25875e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db25875e",
  null
  
)

export default component.exports